import LocalizedPrices from '../../config/static/plan-price-localized'

const timeZoneMap = {
  Andorra: 'EUR',
  Dubai: 'AED',
  Kabul: 'AFN',
  Tirane: 'ALL',
  Yerevan: 'AMD',
  Casey: 'EUR',
  Davis: 'EUR',
  Mawson: 'EUR',
  Palmer: 'EUR',
  Rothera: 'EUR',
  Troll: 'EUR',
  Vostok: 'EUR',
  Buenos_Aires: 'ARS',
  Cordoba: 'ARS',
  Salta: 'ARS',
  Jujuy: 'ARS',
  Tucuman: 'ARS',
  Catamarca: 'ARS',
  La_Rioja: 'ARS',
  San_Juan: 'ARS',
  Mendoza: 'ARS',
  San_Luis: 'ARS',
  Rio_Gallegos: 'ARS',
  Ushuaia: 'ARS',
  Vienna: 'EUR',
  Lord_Howe: 'AUD',
  Macquarie: 'AUD',
  Hobart: 'AUD',
  Melbourne: 'AUD',
  Sydney: 'AUD',
  Broken_Hill: 'AUD',
  Brisbane: 'AUD',
  Lindeman: 'AUD',
  Adelaide: 'AUD',
  Darwin: 'AUD',
  Perth: 'AUD',
  Eucla: 'AUD',
  Baku: 'AZN',
  Barbados: 'EUR',
  Dhaka: 'BDT',
  Brussels: 'EUR',
  Sofia: 'BGN',
  Bermuda: 'BMD',
  Brunei: 'BND',
  La_Paz: 'BOB',
  Noronha: 'BRL',
  Belem: 'BRL',
  Fortaleza: 'BRL',
  Recife: 'BRL',
  Araguaina: 'BRL',
  Maceio: 'BRL',
  Bahia: 'BRL',
  Sao_Paulo: 'BRL',
  Campo_Grande: 'BRL',
  Cuiaba: 'BRL',
  Santarem: 'BRL',
  Porto_Velho: 'BRL',
  Boa_Vista: 'BRL',
  Manaus: 'BRL',
  Eirunepe: 'BRL',
  Rio_Branco: 'BRL',
  Minsk: 'BYN',
  Belize: 'BZD',
  St_Johns: 'CAD',
  Halifax: 'CAD',
  Glace_Bay: 'CAD',
  Moncton: 'CAD',
  Goose_Bay: 'CAD',
  Toronto: 'CAD',
  Nipigon: 'CAD',
  Thunder_Bay: 'CAD',
  Iqaluit: 'CAD',
  Pangnirtung: 'CAD',
  Winnipeg: 'CAD',
  Rainy_River: 'CAD',
  Resolute: 'CAD',
  Rankin_Inlet: 'CAD',
  Regina: 'CAD',
  Swift_Current: 'CAD',
  Edmonton: 'CAD',
  Cambridge_Bay: 'CAD',
  Yellowknife: 'CAD',
  Inuvik: 'CAD',
  Dawson_Creek: 'CAD',
  Fort_Nelson: 'CAD',
  Whitehorse: 'CAD',
  Dawson: 'CAD',
  Vancouver: 'CAD',
  Santiago: 'CLP',
  Punta_Arenas: 'CLP',
  Easter: 'CLP',
  Shanghai: 'CNY',
  Urumqi: 'CNY',
  Bogota: 'COP',
  Costa_Rica: 'CRC',
  Cape_Verde: 'CVE',
  Christmas: 'AUD',
  Nicosia: 'EUR',
  Famagusta: 'EUR',
  Prague: 'CZK',
  Berlin: 'EUR',
  Santo_Domingo: 'DOP',
  Algiers: 'DZD',
  Tallinn: 'EUR',
  Cairo: 'EGP',
  Madrid: 'EUR',
  Ceuta: 'EUR',
  Canary: 'EUR',
  Helsinki: 'EUR',
  Fiji: 'FJD',
  Paris: 'EUR',
  London: 'GBP',
  Tbilisi: 'GEL',
  Gibraltar: 'EUR',
  Athens: 'EUR',
  Guatemala: 'GTQ',
  Bissau: 'XOF',
  Guyana: 'GYD',
  Hong_Kong: 'HKD',
  Tegucigalpa: 'HNL',
  'Port-au-Prince': 'HTG',
  Budapest: 'EUR',
  Jerusalem: 'ILS',
  Kolkata: 'INR',
  Reykjavik: 'EUR',
  Rome: 'EUR',
  Jamaica: 'JMD',
  Amman: 'JOD',
  Tokyo: 'JPY',
  Nairobi: 'KES',
  Bishkek: 'KGS',
  Tarawa: 'AUD',
  Kanton: 'AUD',
  Kiritimati: 'AUD',
  Seoul: 'KRW',
  Almaty: 'KZT',
  Qyzylorda: 'KZT',
  Qostanay: 'KZT',
  Aqtobe: 'KZT',
  Aqtau: 'KZT',
  Atyrau: 'KZT',
  Oral: 'KZT',
  Colombo: 'LKR',
  Monrovia: 'LRD',
  Vilnius: 'EUR',
  Luxembourg: 'EUR',
  Riga: 'EUR',
  Casablanca: 'MAD',
  Monaco: 'EUR',
  Chisinau: 'EUR',
  Macau: 'MOP',
  Malta: 'EUR',
  Mauritius: 'MUR',
  Maldives: 'MVR',
  Mexico_City: 'MXN',
  Cancun: 'MXN',
  Merida: 'MXN',
  Monterrey: 'MXN',
  Matamoros: 'MXN',
  Mazatlan: 'MXN',
  Chihuahua: 'MXN',
  Ojinaga: 'MXN',
  Hermosillo: 'MXN',
  Tijuana: 'MXN',
  Bahia_Banderas: 'MXN',
  Maputo: 'MZN',
  Windhoek: 'NAD',
  Lagos: 'NGN',
  Managua: 'NIO',
  Amsterdam: 'EUR',
  Oslo: 'EUR',
  Kathmandu: 'NPR',
  Auckland: 'NZD',
  Chatham: 'NZD',
  Panama: 'PAB',
  Lima: 'PEN',
  Port_Moresby: 'PGK',
  Bougainville: 'PGK',
  Manila: 'PHP',
  Karachi: 'PKR',
  Warsaw: 'PLN',
  Gaza: 'ILS',
  Hebron: 'ILS',
  Lisbon: 'EUR',
  Madeira: 'EUR',
  Azores: 'EUR',
  Asuncion: 'PYG',
  Qatar: 'QAR',
  Bucharest: 'EUR',
  Belgrade: 'RSD',
  Riyadh: 'SAR',
  Guadalcanal: 'SBD',
  Mahe: 'SCR',
  Khartoum: 'SDG',
  Stockholm: 'EUR',
  Paramaribo: 'SRD',
  El_Salvador: 'SVC',
  Ndjamena: 'XAF',
  Bangkok: 'THB',
  Dushanbe: 'TJS',
  Tunis: 'TND',
  Tongatapu: 'TOP',
  Istanbul: 'TRY',
  Funafuti: 'AUD',
  Taipei: 'TWD',
  Kiev: 'UAH',
  Uzhgorod: 'UAH',
  Zaporozhye: 'UAH',
  Montevideo: 'UYU',
  Samarkand: 'UZS',
  Tashkent: 'UZS',
  Wallis: 'XPF',
  Johannesburg: 'ZAR',
  Antigua: 'XCD',
  Anguilla: 'XCD',
  Luanda: 'AOA',
  McMurdo: 'EUR',
  DumontDUrville: 'EUR',
  Syowa: 'EUR',
  Aruba: 'AWG',
  Mariehamn: 'EUR',
  Sarajevo: 'BAM',
  Ouagadougou: 'XOF',
  Bahrain: 'BHD',
  Bujumbura: 'BIF',
  'Porto-Novo': 'XOF',
  Gaborone: 'BWP',
  'Blanc-Sablon': 'CAD',
  Atikokan: 'CAD',
  Creston: 'CAD',
  Douala: 'XAF',
  Busingen: 'EUR',
  Djibouti: 'DJF',
  Dominica: 'XCD',
  Addis_Ababa: 'ETB',
  Libreville: 'XAF',
  Grenada: 'XCD',
  Guernsey: 'GBP',
  Accra: 'GHS',
  Conakry: 'GNF',
  Malabo: 'XAF',
  Isle_of_Man: 'GBP',
  Jersey: 'GBP',
  Phnom_Penh: 'KHR',
  Comoro: 'KMF',
  Kuwait: 'KWD',
  Maseru: 'LSL',
  Podgorica: 'EUR',
  Antananarivo: 'MGA',
  Bamako: 'XOF',
  Blantyre: 'MWK',
  Niamey: 'XOF',
  Muscat: 'OMR',
  Kigali: 'RWF',
  Bratislava: 'EUR',
  San_Marino: 'EUR',
  Dakar: 'XOF',
  Mogadishu: 'SOS',
  Lome: 'XOF',
  Dar_es_Salaam: 'TZS',
  Kampala: 'UGX',
  Vatican: 'EUR',
  Aden: 'YER',
  Lusaka: 'ZMW'
}

export function getLocalCurrency () {
  if (typeof document !== 'undefined') {
    const params = (new URL(document.location)).searchParams
    const currency = params.get('currency')
    if (currency && Object.keys(LocalizedPrices.annual).includes(currency)) {
      return currency.toUpperCase()
    } else if (currency) {
      return 'USD'
    }
  }

  let userCity
  if (typeof Intl !== 'undefined') {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const tzArr = userTimeZone.split('/')
    userCity = tzArr[tzArr.length - 1]
  }
  const currency = userCity ? timeZoneMap[userCity] || 'USD' : 'USD'
  return currency
}

export function getLocalCurrencyAmount (period = 'annual', divideAnnual = false) {
  let locale = 'en-US'
  if (typeof navigator !== 'undefined') {
    locale = navigator?.language
  }

  const currency = getLocalCurrency()
  let amount = LocalizedPrices[period][currency]
  if (!amount) {
    amount = LocalizedPrices[period].USD
  }
  if (divideAnnual) {
    amount = amount / 12
  }
  return amount?.toLocaleString(locale, { style: 'currency', currency }) || ''
}
